import React from 'react';
import PropTypes from 'prop-types';
import PreferencesForm from 'containers/preferences/PreferencesFormContainer';
import withTranslate from 'components/withTranslate';
import { usePageTitle } from 'util/usePageTitle';

export const Preferences = ({
  _t,
  rootClassName = 'page-layout',
  shouldRedirect = true,
  onDashboard = false,
}) => {
  usePageTitle(_t('Contact Preferences').join(''), !onDashboard);

  return (
    <div
      className={`preferences ${rootClassName} preferences-page`}
      id={'contact-preferences'}
      data-testid={'preferences'}
    >
      <h2 className="dashboard-title">{_t('Contact Preferences')}</h2>
      <PreferencesForm
        shouldRedirect={shouldRedirect}
        onDashboard={onDashboard}
      />
    </div>
  );
};

export default withTranslate(Preferences);

Preferences.propTypes = {
  _t: PropTypes.func.isRequired,
  rootClassName: PropTypes.string,
  shouldRedirect: PropTypes.bool,
  onDashboard: PropTypes.bool,
};
